<template>
  <v-card
    rounded="xl"
    outlined
    >
    <v-card-title
      class="text-uppercase flex-column align-start"
      >
      <div>
        {{ account.name }}
      </div>

      <v-btn-toggle 
        dense
        mandatory
        v-model="billing"
        v-if="false"
        >
        <v-btn
          :value="null"
          class="caption font-weight-bold"
          >
          Todos
        </v-btn>

        <v-btn
          :value="true"
          class="caption font-weight-bold"
          >
          FC
        </v-btn>

        <v-btn
          :value="false"
          class="caption font-weight-bold"
          >
          NO/FC
        </v-btn>
      </v-btn-toggle> 
    </v-card-title>

    <v-divider></v-divider>

    <v-card-text>
      <balance-header
        ></balance-header>

      <template
        v-for="subAccount in account.subAccounts"
        >
        <div>
          <sub-account
            :subAccount="subAccount"
            @reload="$emit('reload')"
            ></sub-account>
          <v-divider></v-divider>
        </div>
      </template>

      <v-row>
        <v-col
          class="text-subtitle-1"
          cols="7"
          >
          Balance total
        </v-col>

        <v-col
          cols="2"
          class="text-subtitle-1"
          >
        </v-col>

        <v-col
          cols="3"
          class="text-right text-subtitle-1"
          :class="account.balance >= 0 ? '' : 'red--text'"
          >
          $ {{ parseFloat(Math.abs(account.balance || 0)).toLocaleString('es-AR') }}
        </v-col>
      </v-row>

      <v-row
        v-if="account.name != 'Resultado Adelantos'"
        >
        <v-col
          cols="12"
          class="pt-0"
          >
          <create-sub-account
            :account="account"
            @reload="$emit('reload')"
            ></create-sub-account>
        </v-col>

        <v-col
          cols="12"
          class="pt-0"
          >
          <v-btn
            small
            outlined
            block
            color="primary"
            class="rounded-lg"
            @click="downloadReport"
            >
            Descargar reporte
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import BalanceHeader from './Header'
import SubAccount from './SubAccount'

const CreateSubAccount = () => import("@/components/balances/sub_accounts/Create")

export default {
  data: () => ({
    billing: null,
  }),

  props: {
    account: {
      type: Object,
      required: true
    },

    period: {
      type: Array,
      required: false
    }
  },

  components: {
    BalanceHeader,
    SubAccount,
    CreateSubAccount
  },

  methods: {
    downloadReport () {
      if (this.period) {
        window.open(process.env.VUE_APP_RAILS_URL + 'balance_report/' + this.account.id + `?init=${this.period[0]}&end=${this.period.at(-1)}`)
      } else {
        window.open(process.env.VUE_APP_RAILS_URL + 'balance_report/' + this.account.id)
      }
    }
  }
}
</script>
